import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["individualRate", "individualRateEditor"];
  toggleEditor(event){
    event.preventDefault();
    this.individualRateTarget.classList.toggle("hidden");
    this.individualRateEditorTarget.classList.toggle("hidden");
  }
}